import { APP_INITIALIZER, CUSTOM_ELEMENTS_SCHEMA, ErrorHandler, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { Router, RouteReuseStrategy } from "@angular/router";
import { ClipboardModule } from "ngx-clipboard";
import * as Sentry from "@sentry/angular";

import { IonicModule, IonicRouteStrategy, createAnimation } from "@ionic/angular";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./router/app-routing.module";

import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireStorageModule } from "@angular/fire/compat/storage";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import { AngularFireAuthGuard } from "@angular/fire/compat/auth-guard";
import { environment } from "@environments/environment";
import { AuthService } from "src/services/auth/auth.service";

import { SplashScreen } from "@ionic-native/splash-screen/ngx";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { provideHttpClient, withInterceptorsFromDi } from "@angular/common/http";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicStorageModule } from "@ionic/storage-angular";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";

import { Facebook } from "@ionic-native/facebook/ngx";
import { InAppBrowser } from "@awesome-cordova-plugins/in-app-browser/ngx";
import { SocialLogin } from "@capgo/capacitor-social-login";
import { SharedComponentsModule } from "./redesign/components/shared-components.module";

export function waitForFirebaseAuth(authService: AuthService) {
  return async () => {
    await authService.waitForAuthInit();
  };
}

export function initializeSocialLogin() {
  return async () => {
    try {
      await SocialLogin.initialize({
        google: {
          webClientId: "949061229597-3ed6dcpn2qdg72ujukop0nnmp5v1khkk.apps.googleusercontent.com",
          iOSClientId: "949061229597-6hkoa5jh2t27sq2u08n2guqshuv2e8hi.apps.googleusercontent.com",
          mode: "online",
        },
        apple: {},
      });
    } catch (error) {
      console.error("Failed to initialize SocialLogin:", error);
    }
  };
}

function fadeAnimation(_: HTMLElement, opts: any) {
  const enteringEl = opts.enteringEl;
  const leavingEl = opts.leavingEl;

  return createAnimation()
    .addElement(enteringEl)
    .duration(200)
    .fromTo("opacity", 0, 1)
    .addAnimation(createAnimation().addElement(leavingEl).duration(200).fromTo("opacity", 1, 0));
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAuthModule,
    AngularFireStorageModule,
    BrowserModule,
    ClipboardModule,
    FormsModule,
    NgxDatatableModule,
    IonicModule.forRoot({ mode: "ios", navAnimation: fadeAnimation }),
    IonicStorageModule.forRoot(),
    ReactiveFormsModule,
    SharedComponentsModule,
  ],
  providers: [
    AngularFireAuthGuard,
    {
      provide: APP_INITIALIZER,
      useFactory: initializeSocialLogin,
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: waitForFirebaseAuth,
      deps: [AuthService],
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    Facebook,
    InAppBrowser,
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    SplashScreen,
    StatusBar,
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  bootstrap: [AppComponent],
})
export class AppModule {}
